import { pletApiRequest } from './client';

function quiet(fn) {
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'test') {
    return Promise.resolve(null);
  }
  return fn().catch(() => null);
}

export const ClockAPI = {
  putTickets: (campaignId, tickets) =>
    quiet(() =>
      pletApiRequest('/clock/tickets', {
        method: 'PUT',
        body: JSON.stringify({ campaignId, tickets }),
      })
    ),

  listInbox: () =>
    quiet(() => pletApiRequest('/inbox')),

  addInboxItem: (item) =>
    quiet(() =>
      pletApiRequest('/inbox', {
        method: 'POST',
        body: JSON.stringify(item),
      })
    ),

  markRead: (id) =>
    quiet(() =>
      pletApiRequest(`/inbox/${encodeURIComponent(id)}`, {
        method: 'PATCH',
        body: JSON.stringify({ read: true }),
      })
    ),

  deleteInboxItem: (id) =>
    quiet(() =>
      pletApiRequest(`/inbox/${encodeURIComponent(id)}`, {
        method: 'DELETE',
      })
    ),

  replaceInboxItem: (item) =>
    quiet(() =>
      pletApiRequest(`/inbox/${encodeURIComponent(item.id)}`, {
        method: 'PUT',
        body: JSON.stringify(item),
      })
    ),

  markAllRead: () =>
    quiet(() =>
      pletApiRequest('/inbox/read-all', {
        method: 'POST',
        body: JSON.stringify({}),
      })
    ),
};
